import type { FilterDefinition, SelectOption } from "../../../types/chartFilters";

export const P1_SISTEMA_OPTIONS: SelectOption[] = [
  { value: "CAT", label: "Catalunya" },
  { value: "ES",  label: "Espanya"   },
  { value: "EU",  label: "Europa"    },
];

export const P2_SISTEMA_OPTIONS: SelectOption[] = [
  { value: "EU",        label: "Europa"    },
  { value: "Catalunya", label: "Catalunya" },
];

export function makeYearRangeFilter(minYear: number, maxYear: number): FilterDefinition {
  return {
    type:    "yearRange",
    key:     "yearRange",
    label:   "Anys",
    minYear,
    maxYear,
  };
}

export function makeSistemaFilter(
  options: SelectOption[],
  clearable = false
): FilterDefinition {
  return {
    type:     "select",
    key:      "sistema",
    label:    "Font",
    options,
    clearable,
  };
}
